import { useEffect, useState } from "react";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { ShipToAddress } from "./ShiptToAddress";
import { InvoicesAddress } from "./InvoicesAddress";
import { OfferOrderReference } from "./OfferOrderReference";
import PartialShipment from "./PartialShipment";
import OrderOfferNote from "./OrderOfferNote";
import { CollapsibleBasketDetails } from "./CollapsibleBasketDetails";
import OrderAgreement from "./OrderAgreement";
import { Box, Typography } from "@mui/material";
import { useOfferOrder } from "../../../hook/useOfferOrder";
import {
  BoxDataOrderOfferStyled,
  BoxMainOrderOfferStyled,
  ColumnRight,
} from "./CreateOfferOrderForm.style";
import { SalesConditionsDTO } from "../../../../explorer/types/OrderOffer/SalesConditions";
import { AppIconsDocumentChecked } from "../../AppIcons";
import {
  SellConditionsContainer,
} from "./OrderOfferNotification.style";
import DeliveryDate from "./DeliveryDate";
import { SalesCondition } from "./SaleCondition";
import { OrderFromOfferDTO } from "../../../../explorer/types/Basket/OfferDetailsResponse";
import { BasketItem } from "../../../../explorer/types/Basket/BasketItems";
import CircleButton from "../../AppButtons/CircleButton";
import { Constants } from "../../../configuration/Constants";
import { defaultLanguage } from "../../../configuration/defaultSettings";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import CGVAgreement from "./CGVAgreement";

type BasketOfferProps = {
  currency?: string;
  showDiscount?: boolean;

  setFormFields: any;
  formFields: any;

  createChangeHandler: any;
  createChangeValueHandler: any;
  ponValid: any;
  setPonValid: any;
  setDeliveryDateValid:any;
  prices: any;
  items: any;
  typeSubmit: "ORDER" | "OFFER" | "ORDER_FROM_OFFER";
  propsForOrder?: OrderFromOfferDTO;
};

export const CreateOfferOrderForm: React.FC<BasketOfferProps> = ({
  currency,
  showDiscount,

  setFormFields,
  formFields,
  createChangeHandler,
  createChangeValueHandler,
  ponValid,
  setPonValid,
  setDeliveryDateValid,
  items,
  prices,
  typeSubmit,
  propsForOrder,
}) => {
  ///////////////////

  const { t } = useTranslation();
  const brand = useBrands().currentBrandUrl;

  // Language
  const lang = useLanguages().currentLanguage;  
  ////////////////////////////////////
  const offerOfferOrder = useOfferOrder();

  const [customerOfferCode, setCustomerOfferCode] = useState("");
  const [customerOrderCode, setCustomerOrderCode] = useState("");

  type NoteItems = {
    [key: string]: string;
  };

  const [noteItemsValue, setNoteItemsValue] = useState<NoteItems>({});
  const [noteValue, setNoteValue] = useState("");

  const submitItemNote = (rowId: string, itemNote: string) => {
    let _f = createChangeValueHandler("noteItems");
    let _newNoteItemsValue = { ...noteItemsValue, [rowId]: itemNote };
    setNoteItemsValue(_newNoteItemsValue);
    _f(null, _newNoteItemsValue);
  };

  const getItemNote = (rowId: string): string | undefined => {
    return noteItemsValue[rowId];
  };

  const handleChangeNote = () => {
    formFields.note = noteValue;
    createChangeHandler("note");
  };

  const [openSentOfferOrderOK, setOpenSentOfferOrderOK] = useState(false);
  const [openSentOfferOrderError, setOpenSentOfferOrderError] = useState(false);

  const [confirmationMessage, setConfirmationMessage] = useState("");

  const _changeCheckBox =
    (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      e.target.value = "" + !e.target.checked;
      setFormFields({
        ...formFields,
        [key]: e.target.checked,
      });
    };

  const [openSalesCondition, setOpenSalesCondition] = useState(false);
  const [salesConditions, setSalesConditions] =
    useState<SalesConditionsDTO | null>(null);
    const [enable, setEnable] = useState(false);
    


  const getSalesCondition = () => {
    setOpenSalesCondition(!openSalesCondition);
    if (!openSalesCondition) {
      ServiceProvider.OrderOffer.salesConditions(brand)
        .then((result) => {
          setSalesConditions(result);
        })
        .catch((e) => console.error(e));
    }
  };

  const isOFO = () => {
    return "ORDER_FROM_OFFER" === typeSubmit;
  };

  const isOrder = () => {
      return (typeSubmit === "ORDER" || typeSubmit === "ORDER_FROM_OFFER")
  }

    const isOffer = () => {
      return (typeSubmit === "OFFER" )
  }
  useEffect(() => {
    /* ponReference: "",
        partialShipment: false,
        
        deliveryDate: "",
        hasAgreement: false,
      
       */
    getSalesCondition();
    let _f = createChangeValueHandler("noteItems");
    if (isOFO()) {
      if (propsForOrder?.note !== undefined) {
        setNoteValue(propsForOrder?.note);
      }
      let _newNoteItemsValue = noteItemsValue;
      items.forEach((x: BasketItem) => {
        if (x.note != null && x.note !== undefined && x.note != "") {
          _newNoteItemsValue = {
            ..._newNoteItemsValue,
            [x.rowId]: x.note,
          };
        }
        
        setNoteItemsValue(_newNoteItemsValue);
        _f(null, _newNoteItemsValue);
      });
      createChangeValueHandler("offerCode")(null, propsForOrder?.offerCode);
      createChangeValueHandler("customerOfferCode")(
        null,
        propsForOrder?.customerOfferCode
      );
      createChangeValueHandler("note")(null, propsForOrder?.note);
      createChangeValueHandler("sellingCompanyCode")(
        null,
        propsForOrder?.sellingCompanyCode
      );
      createChangeValueHandler("currentLanguage")(
        null,
        propsForOrder?.currentLanguage
      );
      createChangeValueHandler("customerCode")(
        null,
        propsForOrder?.customerCode
      );
    } else {
      setNoteValue("");
      setNoteItemsValue({});
      createChangeValueHandler("note")(null, "");

      createChangeValueHandler("offerCode")(null, "");
      createChangeValueHandler("customerOfferCode")(null, "");
      _f(null, {});

    }
    createChangeValueHandler("partialShipment")(null, true);
    createChangeValueHandler("hasAgreement")(null, false);
    createChangeValueHandler("deliveryDate")(null, "");
    createChangeValueHandler("gcvAgreement")(null, false);
    //createChangeValueHandler("deliveryAddress")(null, "");
    //createChangeValueHandler("invoiceAddress")(null, "");
    createChangeValueHandler("ponReference")(null, "");
  }, []);
  return (
      <>
          <div>
              <BoxMainOrderOfferStyled>
                  <BoxDataOrderOfferStyled>
                      <ShipToAddress
                          value={propsForOrder?.shipTo}
                          onSelectChange={createChangeValueHandler(
                              "deliveryAddress"
                          )}
                          readonly={isOFO()}
                      />
                      <InvoicesAddress value={propsForOrder?.billTo} />
                      <OfferOrderReference
                          isOffer={isOffer()}
                          value={formFields.ponReference}
                          onChange={createChangeHandler("ponReference")}
                          offerReferenceValid={ponValid}
                          onChangeOfferReferenceValid={(value: boolean) => {
                              setPonValid(value);
                          }}
                      />{" "}
                      {(isOrder()) && (
                          <DeliveryDate
                              onChangeDeliveryDateValid={(value: boolean) => {
                                setDeliveryDateValid(value);
                              }}
                              onChange={createChangeValueHandler(
                                  "deliveryDate"
                              )}
                          />
                      )}
                      <PartialShipment
                          defaultValue={true}
                          onChange={createChangeValueHandler("partialShipment")}
                      />
                  </BoxDataOrderOfferStyled>
                  <ColumnRight>
                      <SellConditionsContainer>
                          <Typography>{t("common.salesCondition")}</Typography>
                          <AppIconsDocumentChecked sx={{marginLeft:"7px"}}/>

                      </SellConditionsContainer>

                      <SalesCondition
                          open={openSalesCondition}
                          salesConditions={salesConditions}
                      />
                  </ColumnRight>
              </BoxMainOrderOfferStyled>
              <OrderOfferNote
                  value={noteValue}
                  onChange={createChangeHandler("note")}
              />
              {(isOrder()) && (
                    <>
                  <OrderAgreement
                      value={true}
                      onChange={_changeCheckBox("hasAgreement")}
                      orderAgreementUrl={
                          Constants.SALES_CONDITIONS[lang ?? defaultLanguage]
                      }
                      enable={enable}
                      setEnable={setEnable}
                  />
                  <CGVAgreement
                      value={true}
                      onChange={_changeCheckBox("cgvAgreement")}
                      setEnable={setEnable}
                      enable={enable}
                  />
                  </>
              )}

              <Box>
                  <CollapsibleBasketDetails
                      typeSubmit={typeSubmit}
                      currency={currency}
                      showDiscount={showDiscount}
                      prices={prices}
                      items={items}
                      onSubmitItemNote={submitItemNote}
                      getItemNote={getItemNote}
                  />
              </Box>
          </div>
      </>
  );
};
